import React, { useState, useEffect, useCallback } from 'react'
import { Button, Separator } from '@fs/zion-ui'
import { useUser } from '@fs/zion-user'
import { registerGuest, getGuestDetails, updateRegisteredGuest } from '../global/guest-details'
import useRequestState from '../hooks/useRequestState'

export default function TempREGISTERME() {
  const user = useUser()
  const [isRegistered, setIsRegistered] = useState(false)
  const [isUpdated, setIsUpdated] = useState(false)

  const registerUser = useCallback(() => {
    return registerGuest('CURRENT', user.displayName)
  }, [user.displayName])

  const updateRegistration = useCallback(() => {
    return updateRegisteredGuest('CURRENT', user.displayName)
  }, [user.displayName])

  const checkRegistration = useCallback(() => {
    return getGuestDetails('CURRENT')
  }, [])

  const [registerCurrentUser, registerState] = useRequestState(registerUser)
  const [updateRegisteredUser, updateRegistrationState] = useRequestState(updateRegistration)
  const [checkIfRegistered, checkState] = useRequestState(checkRegistration)

  const handleClick = () => {
    registerCurrentUser().then(() => {
      setIsRegistered(true)
    })
  }

  const handleReregisterClick = () => {
    updateRegisteredUser().then(() => {
      setIsUpdated(true)
    })
  }

  useEffect(() => {
    checkIfRegistered().then((res) => {
      if (res.data?.guestName) {
        setIsRegistered(true)
      }
    })
  }, [checkIfRegistered])

  const isRegLabel = isRegistered ? 'Registered' : 'Unregistered'

  return (
    <>
      <Separator size="xl" />
      <div>You are currently: {checkState.complete && isRegLabel}</div>
      <Separator size="xl" />
      <Button
        emphasis="billboard"
        color="orange"
        disabled={!user || isRegistered || registerState.pending || checkState.pending}
        onClick={handleClick}
      >
        {!registerState.pending && checkState.pending && 'Checking...'}
        {!registerState.pending && checkState.complete && isRegistered && "You're Set"}
        {!registerState.pending && checkState.complete && !isRegistered && 'REGISTER ME'}
        {registerState.pending && 'Registering...'}
      </Button>
      <Separator size="lg" />
      <Button
        emphasis="billboard"
        color="orange"
        disabled={!user || updateRegistrationState.pending || checkState.pending || !isRegLabel}
        onClick={handleReregisterClick}
      >
        {!updateRegistrationState.pending && checkState.pending && 'Checking...'}
        {!updateRegistrationState.pending && checkState.complete && isUpdated && "You're Set Again"}
        {!updateRegistrationState.pending && checkState.complete && !isUpdated && 'UPDATE MY REGISTRATION'}
        {updateRegistrationState.pending && 'Updating...'}
      </Button>
    </>
  )
}
